import {ItemDto} from '../../../../models/Items/IItem';
import {GuidLightDto} from '../../../../models/common/IGuidLight';
import {FillingGuidDto, SaveFillingGuidRequest} from '../../../../models/Recipe/Filling/IFillingGuid';
import FillingForm from '../../shared/FillingForm';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

interface Props { recipes?: GuidLightDto[]; items?: ItemDto[]; fillingData: FillingGuidDto; onSubmit: (value: SaveFillingGuidRequest) => Promise<void>; }
export const EditFilling = ({recipes, items, fillingData, onSubmit}: Props) => {
    const {t} = useAppTranslation();
    return <FillingForm initialData={fillingData} recipes={recipes} items={items} onSubmit={onSubmit} submitLabel={t('recipes:save_filling')}/>;
};
